/** Returns true if is executed client side. Will return false if executed server side. */
export const isRunningClientSide = () => typeof window !== 'undefined'
